// Firebase Web SDK 설정
// Firebase Console > Project Settings > General > Your apps > Web app에서 가져온 설정값

interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  vapidKey: string; // VAPID 키 추가
}

export const firebaseConfig: FirebaseConfig = {
  apiKey: 'AIzaSyBvjvmdEoNayf21hOU03HxzzqZD2A7Hh1c',
  authDomain: 'bellcloud-fcm-2cdc6.firebaseapp.com',
  projectId: 'bellcloud-fcm-2cdc6',
  storageBucket: 'bellcloud-fcm-2cdc6.firebasestorage.app',
  messagingSenderId: '1070462223194',
  appId: '1:1070462223194:web:841cf1d3a640186a792963',
  // VAPID 키 (Firebase Console > Project Settings > Cloud Messaging > Web Push certificates)
  vapidKey: 'BG1VhGXHIEbWRAim4ZOJLDOWqOPUXgZJGorEs6J7Wi8cS1Uwy3vz6YyJEdFF2xpN9bBBvkYttFqUkBk9cqDxLnI',
};

